import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { api } from "@/lib/api";
import useLenis from "@/hooks/useLenis";
import useSEO from "@/hooks/useSEO";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Statement from "@/components/Statement";
import Manifesto from "@/components/Manifesto";
import Apparel from "@/components/Apparel";
import Supplements from "@/components/Supplements";
import Marquee from "@/components/Marquee";
import Programs from "@/components/Programs";
import Creed from "@/components/Creed";
import Footer from "@/components/Footer";
import ProgramDetail from "@/pages/ProgramDetail";
import Turn180 from "@/pages/Turn180";
import MBSApp from "@/pages/MBSApp";
import { Login, Register } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import ChallengeSideTab from "@/components/ChallengeSideTab";

const Home = () => {
  useLenis();
  useSEO({
    title: "Mind. Body. Soul. — Discipline, Faith, Iron. The Overload Order.",
    description:
      "Mind. Body. Soul. — apparel, programs (Ascent · Altitude · Stillness · Iron Order), and the Turn 180 — a 180-day transformation challenge built on faith, iron, and silence.",
  });

  useEffect(() => {
    (async () => {
      try {
        await api.get("/");
      } catch (e) {
        // silent
      }
    })();
  }, []);

  return (
    <div className="relative bg-black text-white">
      <Header />
      <main className="relative">
        <Hero />
        <Marquee />
        <Statement />
        <Manifesto />
        <Apparel />
        <Supplements />
        <Programs />
        <Creed />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ChallengeSideTab />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programs/:slug" element={<ProgramDetail />} />
            <Route path="/challenge" element={<Turn180 />} />
            <Route path="/app" element={<MBSApp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
